import { render } from "./SurveyQ51.vue?vue&type=template&id=6edda12e&scoped=true&ts=true"
import script from "./SurveyQ51.vue?vue&type=script&lang=ts"
export * from "./SurveyQ51.vue?vue&type=script&lang=ts"

import "./SurveyQ51.vue?vue&type=style&index=0&id=6edda12e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6edda12e"]])

export default __exports__